import React from "react";
import { DataWidgetScene } from "@learningblocks/widgets/data-widget-components";
import "./index.css";

export default function DataWidget(props) {
  return (
    <div
      className="dataWidget-container"
      style={{
        maxWidth:
          props.data.tabs.length < 3
            ? "calc(375px + 500px)"
            : props.data.tabs.length < 4
              ? "calc(375px + (500px * 2))"
              : "1880px",
      }}
    >
      <DataWidgetScene
        sceneData={props.data}
        plotCalculations={props.plotFunctions}
      />
    </div>
  );
}
